import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import SearchFilter from "../../../components/SearchFilter";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import InFormInstallAcceptService from "../../../services/informinstallaccept.service";
import Table from "../../../components/Table";
import { formatDate } from "../../../commons/FormatValue";
import {
  filteredItemBySearch,
  filteredItemInArray
} from "../../../utils/ManageArray";
import { formatInputDate } from "../../../utils/Time";

export default function SearchCheck() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(state?.searchValue || null);
  const [data, setData] = useState([]);
  const [Accept, setAccept] = useState([]);

  const searchField = [
    { name: "install_accept_date", label: "วันที่ตรวจรับงาน", type: "date" },
    { name: "id", labelName: "install_accept_no", label: "เลขที่ตรวจรับงาน" }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      width: "110px"
    },
    // {
    //   name: "ประเภทงาน",
    //   selector: (row) => row?.JobType.Job_Type_Name,
    //   sortable: true
    // },
    {
      name: "วันที่แจ้ง",
      selector: (row) => row?.inform_install_job_items?.Install_Doc_Date,
      format: (row) =>
        formatDate(row?.inform_install_job_items?.Install_Doc_Date)
    },
    {
      name: "เลขที่แจ้ง",
      selector: (row) => row?.inform_install_job_items?.Install_Doc_No
    },
    // { name: "รหัสลูกค้า/สาขา", selector: (row) => row?.inform_install_job_items?.BPCustomer?.Cus_Code },
    // {
    //   name: "เลขที่สาขา",
    //   selector: (row) => row?.inform_install_job_items?.BPCustomer?.Cus_NumBranch,
    // },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row?.inform_install_job_items?.BPCustomer.Cus_Name
    },
    {
      name: "ผู้แจ้ง",
      selector: (row) =>
        row?.accept_by_items?.Employee_Name +
        " " +
        row?.accept_by_items?.Employee_Surname
    },
    {
      name: "วันที่ตรวจรับงาน",
      selector: (row) => row?.install_accept_date,
      format: (value) =>
        value?.install_accept_date &&
        formatInputDate(value?.install_accept_date, "Local")?.date
    },
    {
      name: "สถานะการรับ",
      selector: (row) => (row?.inst_reject === true ? "ACCEPT" : "REJECT")
    },
    {
      name: "เหตุผลไม่รับงาน",
      selector: (row) => row?.reject_reason_description?.Reason_Desc
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InFormInstallAcceptService.getAllInFormInstallAccept(),
      callback: (res) => setData(res)
    });

    if (state?.name !== "data") {
      navigate("/installation_work/check", { state: { name: "data" } });
    }
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            text: "ค้นหาข้อมูลตรวจสอบและรับการแจ้งงาน",
            className: "text-center"
          }
        }}
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={state?.Search ? state?.Search : searchField}
              fieldClassName={{
                inputRow: "justify-content-center align-items-center"
              }}
              searchCallback={(search) => {
                setSearchValue(search);
                setAccept(
                  search[1]?.value
                    ? filteredItemInArray(data, "id", search[1]?.value)
                    : search.some(({ value }) => value)
                    ? filteredItemBySearch(data, search)
                    : []
                );
              }}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          element: (
            <Table
              data={Accept}
              column={columns}
              pending={loading}
              pagination
            />
          )
        }}
      />
    </>
  );
}
